import React from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import {
  Add,
  Edit,
  Save,
  Visibility,
  Clear,
  Restore,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LocationOff,
  LocationOn,
  GpsOff,
  GpsFixed,
  VisibilityOff,
} from '@material-ui/icons';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from '@material-ui/core';
import Legend from 'components/Tvendo/Common/Legend';
import LayerCombo, { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import LayerLegend from 'components/Tvendo/Common/LayerLegend';
import { getPolygonPath } from 'services/PolygonPath';

export default function ModalToolbarInfo(props) {
  const {
    classes,
    showNotify,
    route,
    addresses,
    handleClickOpen,
    hoverDescription,
    buttonUpdate,
    updatePolygon,
    routeHistory,
    showAddresses,
    setShowAddresses,
    showOriginalGeometry,
    setShowOriginalGeometry,
    showReferenceRoutes,
    setShowReferenceRoutes,
    createPolygon,
    newPolygon,
    bureaus,
    selectedBureau,
    setSelectedBureau,
    stateFilter,
    setStateFilter,
    layers,
    showMarkerLabels,
    setShowMarkerLabels,
  } = props;
  const { setRoute, setRouteHistory, routePolygon } = props;
  const { originalRoute, setOriginalRoute, setButtonUpdate } = props;

  function startUpdate() {
    setOriginalRoute({ ...route });
    setRouteHistory([route.geometry]);
    setButtonUpdate(true);
  }

  function cancelUpdate() {
    setRoute({ ...originalRoute, geometry: [...originalRoute.geometry] });
    setRouteHistory([]);
    setOriginalRoute(undefined);
    setShowAddresses(true);
    setShowOriginalGeometry(true);
    setShowReferenceRoutes(true);
    setButtonUpdate(false);
  }

  function removeVertex(fromStart = true) {
    let newPath = getPolygonPath(routePolygon.current).map((point) => {
      return {
        lng: point[0],
        lat: point[1],
      };
    });

    newPath.pop();

    if (newPath.length <= 3) {
      showNotify('No se pueden eliminar más vertices', 'info');
      return;
    }

    if (fromStart) {
      newPath.shift();
    } else {
      newPath.pop();
    }

    setRouteHistory([...routeHistory, newPath]);
    setRoute({ ...route, geometry: newPath });
  }

  function historyUndo() {
    if (routeHistory.length > 1) {
      setRoute({ ...route, geometry: routeHistory[routeHistory.length - 2] });
      setRouteHistory(routeHistory.slice(0, routeHistory.length - 1));
    }
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12}>
        {/* Info */}
        <GridContainer>
          <GridItem xs={12}>
            <div className={classes.details}>
              <span>
                Ruta: {route.description}
                {route.layer && (
                  <LayerColorIcon
                    layer={route.layer}
                    style={{ display: 'inline-block', position: 'relative', top: '3px' }}
                  />
                )}
              </span>
              <span>Zona: {route.base_zone_description}</span>
              <span>Direcciones: {addresses.length}</span>

              <Button
                justIcon
                round
                size="sm"
                color="primary"
                className={classes.btnEye}
                onClick={handleClickOpen}
              >
                <Visibility />
              </Button>
              <span>
                Direcciones con marcador:{' '}
                {addresses.filter((address) => address.longitude != '0').length}
              </span>
              <span>
                Direcciones sin marcador:{' '}
                {
                  addresses.filter((address) => address.longitude == '0' || address.latitude == '0')
                    .length
                }
              </span>
            </div>
          </GridItem>
        </GridContainer>

        {/* Edición y título de rutas */}
        <GridContainer>
          <GridItem xs={12}>
            <div className={classes.detailsHover}>
              <span>{hoverDescription}</span>
            </div>
          </GridItem>
          <GridItem xs={12}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <AllowedGuard permission={ConstantPermissions.BASE_ROUTES_POLYGON_UPDATE}>
                {!!route ? (
                  !!route.geometry ? (
                    buttonUpdate ? (
                      <GridContainer>
                        <GridItem xl={2}>
                          <h5>Edicion: </h5>
                          <Tooltip title="Guardar">
                            <Button
                              justIcon
                              round
                              color="success"
                              onClick={updatePolygon}
                              disabled={routeHistory.length <= 1}
                            >
                              <Save />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Cancelar">
                            <Button justIcon round color="danger" onClick={cancelUpdate}>
                              <Clear />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Retroceder">
                            <Button
                              justIcon
                              round
                              color="warning"
                              onClick={historyUndo}
                              disabled={routeHistory.length <= 1}
                            >
                              <Restore />
                            </Button>
                          </Tooltip>
                        </GridItem>
                        <GridItem xl={2}>
                          <h5>Vértices : {route.geometry.length}</h5>
                          <Tooltip title="Eliminar vértice del inicio">
                            <Button
                              justIcon
                              round
                              color="danger"
                              onClick={() => removeVertex(true)}
                            >
                              <KeyboardArrowLeft />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Eliminar vértice del final">
                            <Button
                              justIcon
                              round
                              color="danger"
                              onClick={() => removeVertex(false)}
                            >
                              <KeyboardArrowRight />
                            </Button>
                          </Tooltip>
                        </GridItem>
                        <GridItem xl={2}>
                          <h5>Visibilidad</h5>
                          <Tooltip
                            title={showAddresses ? 'Ocultar direcciones' : 'Ver direcciones'}
                          >
                            <Button
                              justIcon
                              round
                              color="info"
                              onClick={() => setShowAddresses((show) => !show)}
                            >
                              {showAddresses ? <LocationOff /> : <LocationOn />}
                            </Button>
                          </Tooltip>
                          <Tooltip
                            title={
                              showOriginalGeometry ? 'Ocultar polígono guía' : 'Ver polígono guía'
                            }
                          >
                            <Button
                              justIcon
                              round
                              color="info"
                              onClick={() => setShowOriginalGeometry((show) => !show)}
                            >
                              {showOriginalGeometry ? <GpsOff /> : <GpsFixed />}
                            </Button>
                          </Tooltip>
                          <Tooltip
                            title={
                              showReferenceRoutes
                                ? 'Ocultar polígonos de referencia'
                                : 'Ver polígonos de referencia'
                            }
                          >
                            <Button
                              justIcon
                              round
                              color="info"
                              onClick={() => setShowReferenceRoutes((show) => !show)}
                            >
                              {showReferenceRoutes ? <VisibilityOff /> : <Visibility />}
                            </Button>
                          </Tooltip>
                        </GridItem>
                      </GridContainer>
                    ) : (
                      <Button justIcon round color="warning" onClick={startUpdate}>
                        <Edit />
                      </Button>
                    )
                  ) : (
                    <Button
                      justIcon
                      round
                      color="success"
                      onClick={() => {
                        createPolygon();
                      }}
                    >
                      {!!newPolygon ? <Save /> : <Add />}
                    </Button>
                  )
                ) : undefined}
              </AllowedGuard>
            </div>
          </GridItem>
        </GridContainer>

        {/* Filtros */}
        <GridContainer>
          {bureaus.length > 0 && (
            <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Filtro de mesas</InputLabel>
                <Select
                  value={selectedBureau?.id || 'N'}
                  onChange={(e) => {
                    if (e.target.value === 'N') {
                      setSelectedBureau(undefined);
                      return;
                    }
                    setSelectedBureau(bureaus.find((item) => item.id === e.target.value));
                  }}
                >
                  <MenuItem value="N">No filtrar</MenuItem>
                  {bureaus.map((bureau) => (
                    <MenuItem value={bureau.id} key={bureau.id}>
                      {bureau.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </GridItem>
          )}

          <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Filtro por estado:</InputLabel>
              <Select
                value={stateFilter}
                onChange={(e) => {
                  setStateFilter(e.target.value);
                }}
              >
                <MenuItem value="A">Activos</MenuItem>
                <MenuItem value="I">Inactivos</MenuItem>
                <MenuItem value="T">Todo</MenuItem>
              </Select>
            </FormControl>
          </GridItem>

          {layers !== undefined && (
            <>
              <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                <LayerCombo isFilter label="Filtro de capas" layers={layers} />
              </GridItem>
            </>
          )}

          <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
            <FormControlLabel
              label="Mostrar nombres"
              control={
                <Checkbox
                  margin="normal"
                  checked={showMarkerLabels}
                  onChange={(e) => setShowMarkerLabels(e.target.checked)}
                />
              }
            />
          </GridItem>
        </GridContainer>

        {/* Leyendas */}
        <GridContainer style={{ marginTop: '5px' }}>
          {layers !== undefined && (
            <GridItem xs={12} md={6}>
              <LayerLegend extraLayers={[{ color: '#000000', name: 'Ruta actual' }]} />
            </GridItem>
          )}
          <GridItem xs={12} md={6}>
            <Legend
              legends={[
                {
                  imageSrc: '/img/GoogleMarker.png',
                  title: 'Dirección activa',
                },
                {
                  imageSrc: '/img/marker_gray.png',
                  title: 'Dirección inactiva',
                },
              ]}
            />
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
}
